import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { updatePassword } from '@/features/auth/api/update-password';

type Props = Omit<
  UseMutationOptions<unknown, Error, unknown, unknown>,
  'mutationFn'
>;

export const useUpdatePassword = ({ ...props }: Props = {}) => {
  return useMutation({
    mutationFn: updatePassword,
    ...props,
  });
};
